const MeauxminyAlbumsStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/34zYfGetvk75MwtyN4oThG?si=Yd4D06WRRMeD5441yjxPzQ" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-BlfYjfbp3yzzOUQD-4CMRIw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Meauxminy - Visions</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/6VuabdaL17mTNuxhVDeRUD?si=bIKyvilAR4SphXqVWyvTMA" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273b12f570d61f237e614460ea7" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Meauxminy - Meaux Money Less Talk</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/2w4GmbcZts42ijPT8Q7VBE" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273b976464e4a66320036b40206" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Evolution Beat Tape, Vol. 2</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/5j9Ulgroyk6CTYOLkC12mC" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273887a2fa8edd1726b8ec166d3" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Evolution Beat Tape, Vol. 1</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/2tKOvkUPDF6NGGE7H2Qgpd" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27383c769700c919a1781c03e2a" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Reality</strong><br/>
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default MeauxminyAlbumsStatic;